import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
// import { ToastService } from '@common/services/toast.service';
import { ToastServicev2 } from '@app/shared/toast/services';
import { ToastMessageOptions2 } from '@app/shared/toast/models/custom-toast-models';

@Component({
    selector: 'sbpro-toast-view',
    templateUrl: './toast-view.component.html',
    styleUrls: ['toast-view.component.scss'],
})
export class ToastViewComponent implements OnInit, AfterViewInit  {
    @ViewChild('defaultHeader', { static: true }) defaultHeader!: TemplateRef<any>;
    @ViewChild('defaultBody', { static: true }) defaultBody!: TemplateRef<any>;

    constructor(public toastService: ToastServicev2) {}
    ngOnInit() {}

    ngAfterViewInit(): void {
    // Register the default templates with the ToastService
    this.toastService.setDefaultTemplates(this.defaultHeader, this.defaultBody);
  }

}
